import {styled} from '@linaria/react';
import {COLORS} from '../../../../constants/colors';
import {tabletAndUpLinaria} from '../../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../constants/typography';
import {Text} from '../../../atoms/Text/Text';

export const SalesRow = styled.div<{
  $hasCountdown?: boolean;
  $align: 'left' | 'right';
}>`
  display: flex;
  position: relative;
  align-items: center;
  flex-wrap: wrap;
  justify-content: ${props =>
    props.$align === 'right' ? 'flex-end' : 'flex-start'};

  margin-top: 0;

  &[data-has-countdown='true'] {
    ${tabletAndUpLinaria('margin-top: 1.25rem;')}
  }
`;

export const SalesCell = styled.div<{$reverse?: boolean}>`
  display: flex;
  align-items: center;
  flex-direction: ${props => (props.$reverse ? 'row-reverse' : 'row')};
  gap: 4px;

  &:first-child {
    margin-right: 4px;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const Badge = styled.div<{
  $foregroundColor: string;
  $backgroundColor: string;
}>`
  position: relative;
  padding: 0 4px;
  border-radius: 4px;
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: ${FONT_SIZES.px16};
  text-transform: uppercase;
  background-color: ${({$backgroundColor}) => $backgroundColor};
  color: ${({$foregroundColor}) => $foregroundColor};

  [data-largerfont='true'] &,
  [data-reductions-large-font='true'] & {
    font-size: ${FONT_SIZES.px12};
    line-height: ${FONT_SIZES.px18};
  }

  // This is used to display the arrow between countdown and campaign sale badge
  &[data-has-countdown='true'] {
    &:before {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      margin: auto;
      width: 0;
      height: 0;
      top: -5px;
      border-top: 4px solid ${props => props.$backgroundColor};
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
    }
  }
`;

export const StruckPrice = styled(Text)`
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: ${FONT_SIZES.px16};
  color: ${COLORS.strikePriceGrey};

  [data-largerfont='true'] &,
  [data-reductions-large-font='true'] & {
    font-size: ${FONT_SIZES.px12};
    line-height: ${FONT_SIZES.px18};
  }
`;

export const PriceAndReductionsInline = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  ${SalesRow} {
    transform: translateY(1px);
  }
`;
